import React from "react";
import Sidebar from "./SideBar/Sidebar";

const Layout = (props) => {

    const { children } = props

    return (
        <Sidebar children={children} />
    );
};

export default Layout;